import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import ScrollToTop from './components/ScrollToTop';
import WhatsAppButton from './components/WhatsAppButton';

const Home = lazy(() => import('./pages/Home'));
const About = lazy(() => import('./pages/About'));
const ServicesPage = lazy(() => import('./pages/ServicesPage'));
const NewsPage = lazy(() => import('./pages/NewsPage'));
const Contact = lazy(() => import('./pages/Contact'));

function App() {
  return (
    <BrowserRouter>
      <a href="#main-content" className="skip-link">
        Saltar al contenido principal
      </a>
      <ScrollToTop />
      <div className="App">
        <Suspense fallback={<div className="route-loading" role="status" aria-live="polite">Cargando...</div>}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/nosotros" element={<About />} />
            <Route path="/servicios" element={<ServicesPage />} />
            <Route path="/noticias" element={<NewsPage />} />
            <Route path="/contacto" element={<Contact />} />
          </Routes>
        </Suspense>
        <WhatsAppButton />
      </div>
    </BrowserRouter>
  );
}

export default App;
